import {
  CloseCircleOutlined,
  PlusCircleFilled,
  SearchOutlined,
} from "@ant-design/icons";
import {
  Button,
  Col,
  Form,
  Input,
  Layout,
  message,
  Row,
  Table,
  Tooltip,
} from "antd";
import { useForm } from "antd/lib/form/Form";
import React, { useEffect, useState } from "react";
import search from "../../helpers/search";
import useBrand from "../../hooks/useBrands";
import { brandService } from "../../services/BrandService";
import BrandsForm from "../BrandsPage/BrandsForm";
import { brand_default } from "./types";

const { Header, Content } = Layout;

const columns = [
  {
    title: "Brand",
    dataIndex: "brand",
    key: "brand",
  },
  {
    title: "Parent Brand",
    dataIndex: "parent_brand_name",
    key: "parent_brand_name",
  },
  {
    title: "Manufacturer",
    dataIndex: "manufacturer_name",
    key: "manufacturer_name",
  },
];
const BrandPage: React.FC = function () {
  const [form] = useForm();
  const [searching, setSearching] = useState(false);
  const [visible, setVisible] = useState(false);
  const [isCreate, setIsCreate] = useState(false);
  const [brandsToDisplay, setBrandsToDisplay] = useState([]);
  const [state, setState] = useState({
    selected: brand_default,
    data: [],
    pagination: {
      current: 1,
      pageSize: 10,
      total: 0,
    },
    pagination_search: {
      current: 1,
      pageSize: 10,
      total: 0,
    },
  });
  const [brands, loadingbrands] = useBrand(state.pagination.current);
  const onSearch = async (key: string) => {
    const { searchWord } = await form.getFieldsValue();
    if (!searchWord) {
      message.error("Please enter a valid search string!");
      return;
    }

    setSearching(true);
    const searchData = [
      {
        key,
        value: encodeURIComponent(searchWord),
      },
    ];

    const searchedData = await search(searchData, brandService, key);
    setBrandsToDisplay(searchedData.data);

    setState({
      ...state,
      pagination_search: {
        ...state.pagination_search,
        total: searchedData.total,
        current: 1,
      },
    });
    setSearching(false);
  };


  const onClose = async () => {
    const { searchWord } = await form.getFieldsValue();
    setState({
      ...state,
    });
    setSearching(true);
    if (searchWord) {
      const searchData = [
        {
          key: "brand",
          value: encodeURIComponent(searchWord),
        },
      ];

      const searchedData = await search(searchData, brandService, "brand");
      setBrandsToDisplay(searchedData.data);
    } else {
      const searchedData = await brandService.getAll(state.pagination.current);
      const data_brandsToDisplay = searchedData.data.brands.length
        ? searchedData.data.brands
        : brands;
      setBrandsToDisplay(data_brandsToDisplay);
    }

    setSearching(false);
  };


  const handleTableChange = async (pagination: any) => {
    setSearching(true);
    setState({
      ...state,
      data: [],
      pagination: pagination,
    });
    const data = await brandService.getAll(pagination.current);
    setBrandsToDisplay(data.data.brands);
    setSearching(false);
  };

  const handleTableSearchChange = async (pagination: any) => {
    const { searchWord } = await form.getFieldsValue();
    setSearching(true);
    setState({
      ...state,
      data: [],
      pagination_search: pagination,
    });
    const searchData = [
      {
        key: "brand",
        value: encodeURIComponent(searchWord),
        page: pagination.current,
      },
    ];

    const data = await search(searchData, brandService, "brand");
    setBrandsToDisplay(data.data);
    setSearching(false);
  };

  useEffect(() => {
    setBrandsToDisplay(brands.brands);
    setState({
      ...state,
      pagination: {
        ...state.pagination,
        total: brands.total,
      },
    });
  }, [brands]);

  const loading = searching || loadingbrands;

  return (
    <Layout style={{ padding: 20 }}>
      <Header
        style={{
          textAlign: "left",
          backgroundColor: "#F0F2F5",
          padding: 0,
          borderRadius: 15,
        }}
      >
        <Row>
          <Col span={12}>
            <h3 style={{ fontWeight: "bold", paddingLeft: 0 }}>
              Brands (
              <span style={{ color: "#0a1e96" }}>
                {brands && brands.total ? brands.total : 0}
              </span>
              )
            </h3>
          </Col>
          <Col span={12} style={{ textAlign: "right", paddingRight: 0 }}>
            <Button
              onClick={() => {
                setVisible(true);
                setIsCreate(true);
                setState({ ...state, selected: brand_default });
              }}
              type="primary"
              shape="round"
              icon={<PlusCircleFilled />}
              style={{ width: 150 }}
            >
              Add New
            </Button>
          </Col>
        </Row>
      </Header>
      <Content>
        <Row
          style={{
            textAlign: "left",
            backgroundColor: "white",
            padding: 20,
            borderRadius: 10,
            marginTop: 0,
          }}
        >
          <Col span={24}>
            <Row>
              <Col span={24} style={{ fontWeight: "bold" }}>
                What are you looking for?
              </Col>
            </Row>
            <Row style={{ marginTop: 20 }}>
              <Form
                form={form}
                initialValues={{
                  searchWord: "",
                }}
                style={{
                  fontWeight: "bold",
                  display: "flex",
                  width: "100%",
                  justifyContent: 'space-between',
                  flexWrap: 'wrap',
                }}
                onValuesChange={(changedVals) => {
                  if (changedVals.searchWord === "") {
                    onClose();
                  }
                }}
              >
                <Col>
                  <Form.Item
                    name="searchWord"
                    shouldUpdate={(prev, cur) => {
                      if (cur.searchWord === "") {
                        onClose();
                      }
                      return true;
                    }}
                  >
                    <Input
                      style={{ width: 300, borderRadius: 10 }}
                      prefix={<SearchOutlined style={{ color: "#ccc" }} />}
                      placeholder={"Search"}
                      suffix={
                        <Tooltip title="Clear Search">
                          <CloseCircleOutlined
                            onClick={() => {
                              setBrandsToDisplay(brands.brands);
                              setIsCreate(false);
                              setState({
                                ...state,
                                pagination: {
                                  current: 1,
                                  pageSize: 10,
                                  total: brands.total,
                                },
                              });
                              form.setFieldsValue({
                                searchWord: ""
                              });
                            }}
                            style={{
                              color: "rgba(0,0,0,.45)",
                            }}
                          />
                        </Tooltip>
                      }
                    ></Input>
                  </Form.Item>

                </Col>
                <Col style={{ textAlign: "right", paddingRight: 0 }}>
                  <Form.Item>
                    <Button
                      type="primary"
                      shape="round"
                      htmlType="submit"
                      onClick={() => onSearch("brand")}
                      style={{ width: 150 }}
                    >
                      Search By Brand
                    </Button>
                  </Form.Item>

                </Col>
              </Form>

            </Row>
          </Col>
        </Row>

        <Row
          style={{
            padding: 20,
            backgroundColor: "white",
            marginTop: 20,
            borderRadius: 15,
          }}
        >
          <Col span={24}>
            {form.getFieldValue("searchWord") === "" ? (
              <Table
                pagination={state.pagination}
                loading={loading}
                onRow={(record, _) => {
                  return {
                    onClick: () => {
                      setState({
                        ...state,
                        selected: record,
                      });
                      setIsCreate(false);
                      setVisible(true);
                    },
                  };
                }}
                dataSource={brandsToDisplay}
                columns={columns}
                onChange={handleTableChange}
              />
            ) : (
              <Table
                pagination={state.pagination_search}
                loading={loading}
                onRow={(record, _) => {
                  return {
                    onClick: () => {
                      setState({
                        ...state,
                        selected: record,
                      });
                      setIsCreate(false);
                      setVisible(true);
                    },
                  };
                }}
                dataSource={brandsToDisplay}
                columns={columns}
                onChange={handleTableSearchChange}
              />
            )}
          </Col>
        </Row>
      </Content>
      <BrandsForm
        visible={visible}
        values={
          isCreate
            ? { ...brand_default }
            : {
              ...state.selected,
            }
        }
        setVisible={setVisible}
        isCreate={isCreate}
        onClose={onClose}
      />
    </Layout>
  );
};

export default BrandPage;
